import { Component, Input, OnInit } from '@angular/core';
import { AgentService } from '../services/agent.service';
import { AgentPaymentViewHandlerComponent } from './agent-payment-view.handler';
import { SettingService } from '../../system-common/services/setting.service';
import { OfflineService } from '../../offline/offline.service';

@Component({
  selector: 'sym-agent-payment-view',
  templateUrl: './agent-payment-view.component.html',
  styleUrls: ['./agent-payment-view.component.scss'],
})
export class AgentPaymentViewComponent extends AgentPaymentViewHandlerComponent {
  constructor(
    agentService: AgentService,
    public settingService: SettingService,
    protected offlineService: OfflineService
  ) {
    super(agentService, settingService, offlineService);
  }
  ngOnInit() {
    super.ngOnInit();
  }
}
